import React, { RefObject } from "react"

interface SvgCanvasProps {
  containerRef: RefObject<HTMLDivElement>
  svgWrapperRef: RefObject<HTMLDivElement>
  zoom: number
  pan: { x: number; y: number }
  isDragging: boolean
  onMouseDown: (e: React.MouseEvent) => void
  onMouseMove: (e: React.MouseEvent) => void
  onMouseUp: () => void
  onTouchStart: (e: React.TouchEvent) => void
  onTouchMove: (e: React.TouchEvent) => void
  onTouchEnd: () => void
  onWheel: (e: React.WheelEvent) => void
}

const SvgCanvas: React.FC<SvgCanvasProps> = ({
  containerRef,
  svgWrapperRef,
  zoom,
  pan,
  isDragging,
  onMouseDown,
  onMouseMove,
  onMouseUp,
  onTouchStart,
  onTouchMove,
  onTouchEnd,
  onWheel,
}) => {
  return (
    <div
      role="presentation"
      className="absolute inset-0 overflow-hidden bg-gray-50"
      data-testid="settings-venue-plan-editor-canvas"
      onMouseDown={onMouseDown}
      onMouseMove={onMouseMove}
      onMouseUp={onMouseUp}
      onMouseLeave={onMouseUp}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
      onWheel={onWheel}
    >
      <div
        ref={svgWrapperRef}
        style={{
          transform: `translate(${pan.x}px, ${pan.y}px) scale(${zoom / 100})`,
          transformOrigin: "0 0",
          cursor: isDragging ? "grabbing" : "grab",
          width: "100%",
          height: "100%",
        }}
      >
        <div ref={containerRef} />
      </div>
    </div>
  )
}

export default SvgCanvas
